import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import "../../styles/subscription.css";

export default function PaymentSuccessPage() {
  return (
    <div className="sub-page sub-result-page">
      <div className="sub-result-card success">
        <CheckCircle2 size={48} />
        <h1>Payment successful</h1>
        <p>Your subscription has been updated. Features are unlocked immediately.</p>
        <Link to="/dashboard" className="sub-btn sub-btn-primary">
          Go to dashboard <ArrowRight size={15} />
        </Link>
        <Link to="/settings/subscription" className="sub-btn sub-btn-ghost">View billing</Link>
      </div>
    </div>
  );
}
